import React from "react";
import { DatasetProvider } from "../../api/endpoints/Subset";
import EcmwfLogo from "./providers/ecmwf.svg";
import CamsLogo from "./providers/cams.svg";
import C3SLogo from "./providers/c3s.svg";

interface Props {
  provider: DatasetProvider
}

type LogoSpec = {
  src: string;
  ratio: number;
  title: string;
}

const PROVIDER_LOGOS: Record<DatasetProvider, LogoSpec> = {
  ecmwf: {
    src: EcmwfLogo,
    ratio: 0.6,
    title: "ECMWF"
  },
  cams: {
    src: CamsLogo,
    ratio: 1,
    title: "CAMS"
  },
  c3s: {
    src: C3SLogo,
    ratio: 1,
    title: "C3S"
  }
}

const DatasetProviderLogo = (props: Props) => {
  const { provider } = props;

  const logo = PROVIDER_LOGOS[provider];
  const imageHeight = `${100 * logo.ratio}%`;

  return (
    <div className="dataset-provider-logo">
      <img className="logo-image" src={logo.src} alt={logo.title} style={{ height: imageHeight }} />
    </div>
  )
}

export default DatasetProviderLogo;
